import React from "react";
import * as styles from "./CruiseDrawerHeader.module.scss";
import { Icon, SanityImage } from "@silversea-ssc/ui-components-react";
import { CruiseCardModel } from "components/CruiseCard/types";
import { t } from "@lingui/core/macro";
import { nonBreakingSpaceCruiseName } from "src/utils/cruise";
import Dates from "components/CruiseCard/Dates/Dates";
import { Trans } from "@lingui/react/macro";

type Props = {
  cruiseCard: CruiseCardModel;
  cruiseName: string;
};

const CruiseDrawerHeader: React.FC<Props> = ({ cruiseCard, cruiseName }) => {
  const cruiseCode = cruiseCard.voyageCode;
  return (
    <header className={styles.header}>
      <SanityImage
        image={cruiseCard.image}
        width={480}
        height={200}
        className={styles.backgroundImage}
        alt={cruiseName}
      />
      <section className={styles.content}>
        <div className={styles.title}>
          {nonBreakingSpaceCruiseName(cruiseCard.departurePort?.name || "")}{" "}
          {t`port-to-port`}
          <wbr />{" "}
          {nonBreakingSpaceCruiseName(cruiseCard.arrivalPort?.name || "")}
        </div>
        <div className={styles.dates} suppressHydrationWarning>
          <Dates
            departureDate={cruiseCard.departureDate}
            arrivalDate={cruiseCard.arrivalDate}
            durationDays={cruiseCard.durationInDays}
            separator="bullet"
          />
        </div>

        <div className={styles.context}>
          <div className={styles.ship}>
            <Icon name="ship-lateral-stroke" padding={"inline-right"} />{" "}
            {cruiseCard.shipName} | <Trans>Voyage number #{cruiseCode}</Trans>
          </div>
        </div>
      </section>
    </header>
  );
};
export default CruiseDrawerHeader;
